const { REACT_APP_Media_Root_Path_URL } = process.env;

export const defaultRestaurantImage = REACT_APP_Media_Root_Path_URL + '/mweb/rest.png';
export const defaultMenuItemImage = REACT_APP_Media_Root_Path_URL + '/mweb/diet.png';
export const HOME = '/home';
export const EXIT_PAGE = REACT_APP_Media_Root_Path_URL + '/mweb/exit-page.png';

// home

export const notfound = REACT_APP_Media_Root_Path_URL + '/mweb/not-found-plate2.webp';
export const search = REACT_APP_Media_Root_Path_URL + '/mweb/phase2/search.webp';
export const QrScan = REACT_APP_Media_Root_Path_URL + '/mweb/qrScan.png';
export const QR_NOT_FOUND = REACT_APP_Media_Root_Path_URL + '/mweb/qr-not-found.webp';
export const PAGE_LOADER = REACT_APP_Media_Root_Path_URL + '/mweb/loader.gif';

// login
export const promoImg1 = REACT_APP_Media_Root_Path_URL + '/mweb/promo-img1.svg';
export const promoImg2 = REACT_APP_Media_Root_Path_URL + '/mweb/promo-img2.svg';
export const promoImg3 = REACT_APP_Media_Root_Path_URL + '/mweb/promo-img3.svg';
export const openLock = REACT_APP_Media_Root_Path_URL + '/mweb/lock3un.webp';
export const infoTag = REACT_APP_Media_Root_Path_URL + '/mweb/info-red.png';
export const closedLock = REACT_APP_Media_Root_Path_URL + '/mweb/closedlock2.webp';
export const loginTop = REACT_APP_Media_Root_Path_URL + '/mweb/top.webp';
export const deliverySelected3 = REACT_APP_Media_Root_Path_URL + '/mweb/delivery-selected3.png';
export const LOGIN_BANNER = REACT_APP_Media_Root_Path_URL + '/mweb/no-login-banner.webp';
export const INFO_TIP = REACT_APP_Media_Root_Path_URL + '/mweb/info-tip.png';
export const SAFE_ICON = REACT_APP_Media_Root_Path_URL + '/mweb/safe_icon.gif';

export const dineInSelected3 = REACT_APP_Media_Root_Path_URL + '/mweb/dine-in-selected3.png';
export const takeawaySelected3 = REACT_APP_Media_Root_Path_URL + '/mweb/takeaway-selected3.png';
export const unknown4 = REACT_APP_Media_Root_Path_URL + '/mweb/unknown4.webp';

// menu
export const goldenwallet = REACT_APP_Media_Root_Path_URL + '/mweb/golden-wallet1.webp';
export const GOLDEN_WALLET = REACT_APP_Media_Root_Path_URL + '/mweb/golden-wallet1.png';
export const CONFETTI_ICON = REACT_APP_Media_Root_Path_URL + '/mweb/confetti_icon.png';
export const veg = REACT_APP_Media_Root_Path_URL + '/mweb/phase2/veg-icon.webp';
export const emptyCart = REACT_APP_Media_Root_Path_URL + '/mweb/deletecart2.webp';
export const search3 = REACT_APP_Media_Root_Path_URL + '/mweb/Search2.png';
export const discountCard = REACT_APP_Media_Root_Path_URL + '/mweb/banner.webp';
export const leftarrow7 = REACT_APP_Media_Root_Path_URL + '/mweb/phase2/arrow-left.png';
export const FILTER_ICON = REACT_APP_Media_Root_Path_URL + '/mweb/filter-icon.webp';
export const RED_FILTER_ICON = REACT_APP_Media_Root_Path_URL + '/mweb/red-filter.webp';
export const EXCELLENT_TASTE = REACT_APP_Media_Root_Path_URL + '/mweb/excellent-taste.webp';
export const ADEQUATE_QUANTITY = REACT_APP_Media_Root_Path_URL + '/mweb/adequate-quantity.webp';
export const VALUE_FOR_MONEY = REACT_APP_Media_Root_Path_URL + '/mweb/value-for-money.webp';
export const PACKAGING_SERVICE = REACT_APP_Media_Root_Path_URL + '/mweb/package-service.webp';
export const RED_EXPAND = REACT_APP_Media_Root_Path_URL + '/mweb/red-expand.png';
export const SUCCESS_TICK = REACT_APP_Media_Root_Path_URL + '/mweb/success-tick.gif';
export const CROSS_CLOSE_WHITE = REACT_APP_Media_Root_Path_URL + '/mweb/cross-close-white.png';
export const CROSS_CLOSE_BLACK = REACT_APP_Media_Root_Path_URL + '/mweb/cross-close-black.png';
export const CHANGE_LANGUAGE = REACT_APP_Media_Root_Path_URL + '/mweb/change_language.svg';
export const CHANGE_LANGUAGE_DEFAULT =
  REACT_APP_Media_Root_Path_URL + '/mweb/change_language_default.svg';
export const LANG_ENG = REACT_APP_Media_Root_Path_URL + '/mweb/lang_eng.svg';
export const LANG_INDO = REACT_APP_Media_Root_Path_URL + '/mweb/lang_indo.svg';
export const LANGUAGE_ELLIPSE = REACT_APP_Media_Root_Path_URL + '/mweb/language_ellipse.svg';
// order status
export const tooltip = REACT_APP_Media_Root_Path_URL + '/mweb/tooltip1.webp';
export const paid = REACT_APP_Media_Root_Path_URL + '/mweb/paid.png';
export const waveLine = REACT_APP_Media_Root_Path_URL + '/mweb/waveline.webp';
export const arrowright = REACT_APP_Media_Root_Path_URL + '/mweb/arrowright2.webp';
export const GroupRestaurant = REACT_APP_Media_Root_Path_URL + '/mweb/grouprestaurant.png';
export const closeicon = REACT_APP_Media_Root_Path_URL + '/mweb/close-cross.webp';
export const foodIsReady = REACT_APP_Media_Root_Path_URL + '/mweb/food_is_ready.webp';
export const ForkKnife = REACT_APP_Media_Root_Path_URL + '/mweb/dinner.webp';
export const loc = REACT_APP_Media_Root_Path_URL + '/mweb/location-icon2.webp';
export const profileEmail = REACT_APP_Media_Root_Path_URL + '/mweb/profile-email.svg';
export const preLoader = REACT_APP_Media_Root_Path_URL + '/mweb/preloader_horiz.gif';
export const calendar = REACT_APP_Media_Root_Path_URL + '/mweb/phase2/calendar.png';
export const bowlIcon = REACT_APP_Media_Root_Path_URL + '/mweb/bowl-with-something.webp';
export const BLUE_RIGHT_ARROW = REACT_APP_Media_Root_Path_URL + '/mweb/right-arrow-blue.webp';
export const INFO_ICON = REACT_APP_Media_Root_Path_URL + '/mweb/info-icon.webp';
export const INFO_ICON_WHITE = REACT_APP_Media_Root_Path_URL + '/mweb/info-icon-white.png';

export const noOrders = REACT_APP_Media_Root_Path_URL + '/mweb/no-orders2.webp';
export const orderStatus4dineIn =
  REACT_APP_Media_Root_Path_URL + '/mweb/order--status4dine-in.webm';
export const orderStatusDriver2 =
  REACT_APP_Media_Root_Path_URL + '/mweb/order--status--driver2.webm';
export const whatsapp2 = REACT_APP_Media_Root_Path_URL + '/mweb/whatsapp2.webp';
export const phone = REACT_APP_Media_Root_Path_URL + '/mweb/phone.webp';
export const backArrow = REACT_APP_Media_Root_Path_URL + '/mweb/back-white-arrow1.webp';
export const backArrowBlack = REACT_APP_Media_Root_Path_URL + '/mweb/arrowbg2.webp';
export const orderHeader = REACT_APP_Media_Root_Path_URL + '/mweb/order-header.png';

export const leftArrow = REACT_APP_Media_Root_Path_URL + '/mweb/arrowbg2.png';
export const whiteArrow = REACT_APP_Media_Root_Path_URL + '/mweb/back-white-arrow1.webp';
export const deliveryMan = REACT_APP_Media_Root_Path_URL + '/user-app/icons/delivery-man.svg';
export const white_phone = REACT_APP_Media_Root_Path_URL + '/user-app/icons/white_phone.svg';
export const cashbackImg = REACT_APP_Media_Root_Path_URL + '/mweb/cashbackImg.png';
export const Allergy_Icon = REACT_APP_Media_Root_Path_URL + '/mweb/allergy-icon.webp';
export const BIG_ARROW_RIGHT = REACT_APP_Media_Root_Path_URL + '/mweb/big-arrow-right.png';
export const TOOLTIP_FACE = REACT_APP_Media_Root_Path_URL + '/mweb/tooltip-face.png';
export const LOYALTY_YOGA = REACT_APP_Media_Root_Path_URL + '/mweb/loyalty_yoga.png';
export const LOYALTY_EARNED = REACT_APP_Media_Root_Path_URL + '/mweb/loyalty_earned.png';
export const SHARE_REFERRAL = REACT_APP_Media_Root_Path_URL + '/mweb/share_referral.png';
export const REFER_A_FREIND = REACT_APP_Media_Root_Path_URL + '/mweb/refer_a_friend.png';
export const REFERRAL_WON = REACT_APP_Media_Root_Path_URL + '/mweb/referral_won.png';
export const REFER_BLUE = REACT_APP_Media_Root_Path_URL + '/mweb/refer_blue.png';

// Profile
export const allergyAdded = REACT_APP_Media_Root_Path_URL + '/mweb/allergy-added.webp';
export const deleteBinLine = REACT_APP_Media_Root_Path_URL + '/mweb/delete-bin-line.webp';
export const AddItems = REACT_APP_Media_Root_Path_URL + '/mweb/shoppingicon1.webp';
export const order = REACT_APP_Media_Root_Path_URL + '/mweb/order-popup.webp';
export const earnCashback = REACT_APP_Media_Root_Path_URL + '/mweb/earn-cashback.webp';

export const redeem = REACT_APP_Media_Root_Path_URL + '/mweb/rm-cashback.webp';
export const enjoydiscounts = REACT_APP_Media_Root_Path_URL + '/mweb/enjoy-discounts.webp';
export const termsConditionIcon = REACT_APP_Media_Root_Path_URL + '/mweb/help3.webp';
export const logoutIcon = REACT_APP_Media_Root_Path_URL + '/mweb/logout3.webp';
export const arrowRight = REACT_APP_Media_Root_Path_URL + '/mweb/arrowright2.webp';
export const arrowRightWhite = REACT_APP_Media_Root_Path_URL + '/mweb/halfarrow2.webp';
export const notesIcon = REACT_APP_Media_Root_Path_URL + '/mweb/ui-with-clip-icon2.webp';
export const checkmark = REACT_APP_Media_Root_Path_URL + '/mweb/phase2/checkmark.webp';
export const googleLogo = REACT_APP_Media_Root_Path_URL + '/mweb/google.webp';

export const fbLogo = REACT_APP_Media_Root_Path_URL + '/mweb/facebook-logo.webp';
export const man3profile = REACT_APP_Media_Root_Path_URL + '/mweb/man3profile.webp';

export const woman3profile = REACT_APP_Media_Root_Path_URL + '/mweb/woman3profile.webp';
export const goldtrophy = REACT_APP_Media_Root_Path_URL + '/mweb/gold-trophy.webp';
export const LoyaltyProgram = REACT_APP_Media_Root_Path_URL + '/mweb/loyaltyBanner2.png';

export const defaultImg = REACT_APP_Media_Root_Path_URL + '/mweb/order-plate1.png';
export const chefOn = REACT_APP_Media_Root_Path_URL + '/mweb/chef_on_plate.webp';
export const redcamera = REACT_APP_Media_Root_Path_URL + '/mweb/red-camera-icon.webp';
export const leftarrow5 = REACT_APP_Media_Root_Path_URL + '/mweb/phase2/arrow-left.png';
export const hamburger = REACT_APP_Media_Root_Path_URL + '/mweb/phase2/hamburger.png';
export const profile = REACT_APP_Media_Root_Path_URL + '/mweb/profile.svg';
export const search2 = REACT_APP_Media_Root_Path_URL + '/mweb/light-gray-search.png';
export const LOYALTY_ICON = REACT_APP_Media_Root_Path_URL + '/mweb/loyalty-icon.png';
export const MYORDERS_ICON = REACT_APP_Media_Root_Path_URL + '/mweb/myorders-icon.png';
export const RM_COIN = REACT_APP_Media_Root_Path_URL + '/mweb/rm-coin.png';
export const easyeatLogoTextless =
  REACT_APP_Media_Root_Path_URL + '/mweb/easyeat-logo-textless.png';
export const PROFILE_BIRTHDAY = REACT_APP_Media_Root_Path_URL + '/mweb/profile_birthday.png';
export const PROFILE_SUPPORT = REACT_APP_Media_Root_Path_URL + '/mweb/profile_support.png';

// accordian
export const accordianexpand = REACT_APP_Media_Root_Path_URL + '/mweb/accordiancollapse1.webp';

// payments
export const current3 = REACT_APP_Media_Root_Path_URL + '/mweb/current3.webp';
export const shield2 = REACT_APP_Media_Root_Path_URL + '/mweb/shield2.webp';
export const fpxPayment = REACT_APP_Media_Root_Path_URL + '/mweb/fpx.webp';
export const payLater = REACT_APP_Media_Root_Path_URL + '/user-app/payment-options/payLater.svg';
export const PAY_ONLINE_AI = REACT_APP_Media_Root_Path_URL + '/mweb/pay_online_ai.webm';
export const PAY_ONLINE_ID = REACT_APP_Media_Root_Path_URL + '/mweb/pay_online_id.webm';
export const PAYMENT_INITIATED = REACT_APP_Media_Root_Path_URL + '/mweb/payment_initiated.webm';
export const PAYMENT_PROCESSING = REACT_APP_Media_Root_Path_URL + '/mweb/payment_processing.webm';
export const OTHER_PAYMENT_OPTIONS = REACT_APP_Media_Root_Path_URL + '/mweb/otherpaymentid.webp';
export const GOPAY_PAYMENT = REACT_APP_Media_Root_Path_URL + '/mweb/gopay_new.webp';

// popups
export const locationtargetUncompressed2 =
  REACT_APP_Media_Root_Path_URL + '/mweb/location-target-bg-only.webp';
export const search4 = REACT_APP_Media_Root_Path_URL + '/mweb/Search1.webp';
export const closeIcon = REACT_APP_Media_Root_Path_URL + '/mweb/closeiconblack.webp';
export const locationIcon = REACT_APP_Media_Root_Path_URL + '/mweb/location-icon2.webp';
export const locationTargetIcon = REACT_APP_Media_Root_Path_URL + '/mweb/location-target-icon.webp';
export const quickservices = REACT_APP_Media_Root_Path_URL + '/mweb/quickservices.webp';
export const resclose = REACT_APP_Media_Root_Path_URL + '/mweb/close.webp';
export const rescloseId = REACT_APP_Media_Root_Path_URL + '/mweb/close-id.png';

export const locationIllustration2pointer =
  REACT_APP_Media_Root_Path_URL + '/mweb/location-illustration-2pointer.webp';
export const trashIcon = REACT_APP_Media_Root_Path_URL + '/mweb/trash-icon-with-page.webp';
export const cartEmpty1 = REACT_APP_Media_Root_Path_URL + '/mweb/cart-empty1.png';
export const NoCoupon = REACT_APP_Media_Root_Path_URL + '/mweb/voucher-with-sad-red-face4.webp';
export const easyeaticon = REACT_APP_Media_Root_Path_URL + '/mweb/phase2/easyeat_icon.webp';
export const deliveryGuy = REACT_APP_Media_Root_Path_URL + '/mweb/freeDeliveryGuy.webp';
export const ClosePopUp = REACT_APP_Media_Root_Path_URL + '/mweb/closePopUp.webp';
export const plus = REACT_APP_Media_Root_Path_URL + '/mweb/phase2/plus.webp';
export const imageNone = REACT_APP_Media_Root_Path_URL + '/mweb/image_none2.webp';
export const ADDRESS_NOT_FOUND = REACT_APP_Media_Root_Path_URL + '/mweb/address_not_found.webp';
export const RED_RIGHT_ARROW = REACT_APP_Media_Root_Path_URL + '/mweb/red-right-arrow.webp';

export const earn = REACT_APP_Media_Root_Path_URL + '/mweb/earn-cashback.webp';
export const enjoy = REACT_APP_Media_Root_Path_URL + '/mweb/enjoy-discounts.webp';
export const hourGlass = REACT_APP_Media_Root_Path_URL + '/mweb/hourglass.svg';
export const cashback1 = REACT_APP_Media_Root_Path_URL + '/mweb/cashback1.gif';

export const dineInUnselected3 = REACT_APP_Media_Root_Path_URL + '/mweb/dine-in-unselected3.webp';
export const deliveryUnselected3 =
  REACT_APP_Media_Root_Path_URL + '/mweb/delivery-unselected3.webp';
export const takeawayUnselected3 =
  REACT_APP_Media_Root_Path_URL + '/mweb/takeaway-unselected3.webp';
export const no_package = REACT_APP_Media_Root_Path_URL + '/user-app/images/no_package.svg';
export const paymentTryAgain =
  REACT_APP_Media_Root_Path_URL + '/user-app/images/paymentTryAgain.svg';
export const green_success_tick_compressed =
  REACT_APP_Media_Root_Path_URL + '/mweb/green-success-tick-compressed.gif';
export const CANCEL_ORDER_ICON = REACT_APP_Media_Root_Path_URL + '/mweb/cancel-order-icon.webp';
export const SERVICE_DEFAULT_IMAGE = REACT_APP_Media_Root_Path_URL + '/mweb/service-logo-ee.webp';
export const PACKAGING_IMG = REACT_APP_Media_Root_Path_URL + '/mweb/packaging-img.webp';

// appFooter
export const cart = REACT_APP_Media_Root_Path_URL + '/mweb/cart.webp';
export const coin = REACT_APP_Media_Root_Path_URL + '/mweb/gold-tophy1.webp';
export const rightArrow = REACT_APP_Media_Root_Path_URL + '/mweb/rightarrowblack1.webp';
export const LocationIcon = REACT_APP_Media_Root_Path_URL + '/mweb/location-icon2.webp';
export const closeIcon2 = REACT_APP_Media_Root_Path_URL + '/mweb/close-icon2.webp';
export const NoOrders = REACT_APP_Media_Root_Path_URL + '/mweb/NoOrders.png';
export const NonVegIcon = REACT_APP_Media_Root_Path_URL + '/mweb/nonVegIcon.webp';
export const VegIcon = REACT_APP_Media_Root_Path_URL + '/mweb/vegIcon.webp';

// common
export const close = REACT_APP_Media_Root_Path_URL + '/mweb/white-close.webp';
export const logo = REACT_APP_Media_Root_Path_URL + '/mweb/white-bg-ee-logo.webp';
export const downloadNow = REACT_APP_Media_Root_Path_URL + '/mweb/downloadNowbutton.webp';
export const clock = REACT_APP_Media_Root_Path_URL + '/mweb/unknown4.webp';
export const emptycart = REACT_APP_Media_Root_Path_URL + '/mweb/deletecart1.webp';
export const UPDATE_CART = REACT_APP_Media_Root_Path_URL + '/mweb/update-cart.png';
export const easyeatLogo = REACT_APP_Media_Root_Path_URL + '/mweb/easyeat-logo-textless.png';
export const leftarrow = REACT_APP_Media_Root_Path_URL + '/mweb/phase2/arrow-left.webp';
export const searchIcon = REACT_APP_Media_Root_Path_URL + '/mweb/search2.webp';
export const CloseIcon = REACT_APP_Media_Root_Path_URL + '/mweb/closeiconblack.webp';
export const locationicon = REACT_APP_Media_Root_Path_URL + '/mweb/location-icon2.webp';
export const editicon = REACT_APP_Media_Root_Path_URL + '/mweb/red-edit-icon.svg';
export const bellimage = REACT_APP_Media_Root_Path_URL + '/mweb/bell.png';
export const ShoppingIconRed = REACT_APP_Media_Root_Path_URL + '/mweb/shoppingicon1.webp';
export const SHOPPING_ICON_LIGHT_RED = REACT_APP_Media_Root_Path_URL + '/mweb/loyalty-bag-red.webp';
export const ShoppingIcon = REACT_APP_Media_Root_Path_URL + '/mweb/shoppingicon2.webp';
export const UserIconRed = REACT_APP_Media_Root_Path_URL + '/mweb/usericon1.webp';
export const UserIcon = REACT_APP_Media_Root_Path_URL + '/mweb/usericon2.webp';
export const SearchIconRed = REACT_APP_Media_Root_Path_URL + '/mweb/redsearch1.webp';
export const SearchIcon = REACT_APP_Media_Root_Path_URL + '/mweb/searchicon2.webp';
export const ScanIcon = REACT_APP_Media_Root_Path_URL + '/mweb/scanicon2.webp';
export const CrownIcon = REACT_APP_Media_Root_Path_URL + '/mweb/center.webp';
export const notFound = REACT_APP_Media_Root_Path_URL + '/mweb/404-not-found-plate.webp';
export const redTick = REACT_APP_Media_Root_Path_URL + '/mweb/red-tick.webp';
export const blueArrow = REACT_APP_Media_Root_Path_URL + '/mweb/blue-right-arrow.webp';
export const PARTY_ICON = REACT_APP_Media_Root_Path_URL + '/mweb/confetti.webp';
export const cutlery = REACT_APP_Media_Root_Path_URL + '/user-app/icons/cutlery-1.png';
export const easyeat_default = REACT_APP_Media_Root_Path_URL + '/user-app/icons/wifi-signal.png';
export const exitedShakeGlass =
  REACT_APP_Media_Root_Path_URL + '/mweb/exited-shake-glass-spill.webp';
export const voucherWithGreen =
  REACT_APP_Media_Root_Path_URL + '/mweb/voucher-with-green-tick.webp';

export const starRatingWhite = REACT_APP_Media_Root_Path_URL + '/mweb/star-rating.png';
export const ORANGE_STAR = REACT_APP_Media_Root_Path_URL + '/mweb/orange-star.png';
export const starRatingGrey = REACT_APP_Media_Root_Path_URL + '/mweb/start-rating-gray.png';
export const appleTouchIcon = REACT_APP_Media_Root_Path_URL + '/mweb/apple-touch-icon.png';
export const PROFILE_WHITE = REACT_APP_Media_Root_Path_URL + '/mweb/profile-white.png';
export const PROFILE_RED = REACT_APP_Media_Root_Path_URL + '/mweb/profile-red.png';

// contactUs

export const tablets = REACT_APP_Media_Root_Path_URL + '/mweb/tabs.webp';
export const tablet2 = REACT_APP_Media_Root_Path_URL + '/mweb/tabs2.webp';
export const serviceIcon = REACT_APP_Media_Root_Path_URL + '/mweb/service_icon.webp';
export const digitalMenu = REACT_APP_Media_Root_Path_URL + '/mweb/digitalmenu_icon.webp';
export const networkIcon = REACT_APP_Media_Root_Path_URL + '/mweb/network_icon.webp';
export const businessDashboard =
  REACT_APP_Media_Root_Path_URL + '/mweb/business_dashboard_icon.webp';
export const managerDashboard = REACT_APP_Media_Root_Path_URL + '/mweb/manager_dashboard_icon.webp';
export const serverDashboard = REACT_APP_Media_Root_Path_URL + '/mweb/server_dashboard_icon.webp';
export const competitiveAnalytics =
  REACT_APP_Media_Root_Path_URL + '/mweb/competitive_analytics_icon.webp';
export const userAnalytics = REACT_APP_Media_Root_Path_URL + '/mweb/user_analytics_icon.webp';
export const iphoneApp = REACT_APP_Media_Root_Path_URL + '/mweb/iPhone_app.webp';
export const onlineMoney = REACT_APP_Media_Root_Path_URL + '/mweb/smartphone-online-money.webp';
export const personTablet = REACT_APP_Media_Root_Path_URL + '/mweb/person-tablet.webp';
export const LaptopData = REACT_APP_Media_Root_Path_URL + '/mweb/laptop-data.webp';
export const recipe = REACT_APP_Media_Root_Path_URL + '/mweb/recipe.webp';
export const phone1 = REACT_APP_Media_Root_Path_URL + '/mweb/phone1.webp';

// foodcourt
export const cart2 = REACT_APP_Media_Root_Path_URL + '/mweb/cart.webp';
export const home2 = REACT_APP_Media_Root_Path_URL + '/mweb/home-2.png';
export const boss = REACT_APP_Media_Root_Path_URL + '/mweb/boss.png';

// footer
export const EasyEatLogo = REACT_APP_Media_Root_Path_URL + '/mweb/easyeat_logo_bw.webp';
export const TwitterLogo = REACT_APP_Media_Root_Path_URL + '/mweb/twitter_logo.webp';
export const FacebookLogo = REACT_APP_Media_Root_Path_URL + '/mweb/facebook_logo.webp';
export const SingaporeFlag = REACT_APP_Media_Root_Path_URL + '/mweb/singapore_flag.webp';
export const IndiaFlag = REACT_APP_Media_Root_Path_URL + '/mweb/india_flag.webp';
export const MalaysiaFlag = REACT_APP_Media_Root_Path_URL + '/mweb/malaysia_flag.webp';
export const InstaLogo = REACT_APP_Media_Root_Path_URL + '/mweb/insta_logo.webp';
export const LinkedInLogo = REACT_APP_Media_Root_Path_URL + '/mweb/linkedin_logo.webp';

// loyalty
export const partyPopper = REACT_APP_Media_Root_Path_URL + '/mweb/phase2/party_popper.webp';
export const loyaltyImage = REACT_APP_Media_Root_Path_URL + '/mweb/loyality.webp';

// header
export const coverimg = REACT_APP_Media_Root_Path_URL + '/coverimage/bg8.jpg';
export const backBtnImg = REACT_APP_Media_Root_Path_URL + '/mweb/arrowbg1.webp';

// others
export const easyeatlogo = REACT_APP_Media_Root_Path_URL + '/easyeatlogo.webp';
export const cross_icon = REACT_APP_Media_Root_Path_URL + '/mweb/cross-icon.webp';
export const PROFILE = '/profileHome';

// marketing

export const bBQ = REACT_APP_Media_Root_Path_URL + '/landingpage/barbeque-logo.png';
export const marketingCost = REACT_APP_Media_Root_Path_URL + '/landingpage/cost.png';
export const crgLogo = REACT_APP_Media_Root_Path_URL + '/landingpage/crg-logo.png';
export const customerExp = REACT_APP_Media_Root_Path_URL + '/landingpage/customer-experience.png';
export const digitalMenus = REACT_APP_Media_Root_Path_URL + '/landingpage/digital-menus.png';
export const marketingEE = REACT_APP_Media_Root_Path_URL + '/landingpage/easyeatLogo.png';
export const Ellipse1 = REACT_APP_Media_Root_Path_URL + '/landingpage/Ellipse 1.svg';
export const Ellipse2 = REACT_APP_Media_Root_Path_URL + '/landingpage/Ellipse 1@2x.png';
export const hardwares = REACT_APP_Media_Root_Path_URL + '/landingpage/hardwares.png';
export const papaDom = REACT_APP_Media_Root_Path_URL + '/landingpage/papadom-logo.png';
export const mrFishLogo = REACT_APP_Media_Root_Path_URL + '/landingpage/mrfish-logo.png';
export const owner1 = REACT_APP_Media_Root_Path_URL + '/landingpage/person1.png';
export const owner2 = REACT_APP_Media_Root_Path_URL + '/landingpage/person2.png';
export const owner3 = REACT_APP_Media_Root_Path_URL + '/landingpage/person3.png';
export const realTime = REACT_APP_Media_Root_Path_URL + '/landingpage/real-time.png';
export const lessLabour = REACT_APP_Media_Root_Path_URL + '/landingpage/reduced-labour.png';
export const rotiCanai = REACT_APP_Media_Root_Path_URL + '/landingpage/roticanai-logo.png';
export const saladLogo = REACT_APP_Media_Root_Path_URL + '/landingpage/salad.png';
export const thaiBoy = REACT_APP_Media_Root_Path_URL + '/landingpage/thaiboy-logo.png';
export const saladVideo = REACT_APP_Media_Root_Path_URL + '/landingpage/v1.mp4';
export const teppanyaki = REACT_APP_Media_Root_Path_URL + '/landingpage/teppanyaki-logo.png';
export const infotip = REACT_APP_Media_Root_Path_URL + '/payments-new/info-tip.webp';
export const onlineLogo = REACT_APP_Media_Root_Path_URL + '/payments-new/paymentlogo.webp';
export const paymentLogo = REACT_APP_Media_Root_Path_URL + '/payments-new/Mask Group 39513.webp';
export const activeOrder = REACT_APP_Media_Root_Path_URL + '/mweb/active.webp';
export const thumsUp = REACT_APP_Media_Root_Path_URL + '/mweb/review_thumbs_up.webp';
export const Rmail = REACT_APP_Media_Root_Path_URL + '/mweb/review_mail.webp';
export const loginLogo = REACT_APP_Media_Root_Path_URL + '/mweb/login_logo.webp';
export const loginWhatsapp = REACT_APP_Media_Root_Path_URL + '/mweb/otp_whatsapp.png';
export const loginHand = REACT_APP_Media_Root_Path_URL + '/mweb/otp_hand.png';
export const loginStop = REACT_APP_Media_Root_Path_URL + '/mweb/otp_stop.png';
export const loginGuard = REACT_APP_Media_Root_Path_URL + '/mweb/otp_guard.png';

// Foodcourt
export const FC_CASH_INFO = REACT_APP_Media_Root_Path_URL + '/mweb/fc_cash_info.png';

// Table Change Popup
export const TABLE_CHANGE_GIF = REACT_APP_Media_Root_Path_URL + '/mweb/Table_change.webm';
export const TABLE_CHANGE_ARROW = REACT_APP_Media_Root_Path_URL + '/mweb/tablechagearrow.svg';
